import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import {
  foodRestrictionsQuery,
  recipeQuery,
  sourcesQuery,
  tagsQuery,
} from '@/api'
import EditOrCreateRecipe from '@/features/recipes/EditOrCreateRecipe/EditOrCreateRecipe'
import { languagesQuery } from '@/api/languages'
import { adminsAndAmbassadorsQuery } from '@/api/users'

export const Route = createFileRoute('/recipes_/duplicate/$recipeId')({
  loader: async ({ context: { queryClient }, params }) => {
    const [recipe, tags, allergens, languages, authors, sources] =
      await Promise.all([
        queryClient.ensureQueryData(recipeQuery(params.recipeId)),
        queryClient.ensureQueryData(tagsQuery),
        queryClient.ensureQueryData(foodRestrictionsQuery),
        queryClient.ensureQueryData(languagesQuery),
        queryClient.ensureQueryData(adminsAndAmbassadorsQuery),
        queryClient.ensureQueryData(sourcesQuery),
      ])

    return { recipe, tags, allergens, languages, authors, sources }
  },
  component: RecipeComponent,
})

function RecipeComponent() {
  const { tags, recipe, allergens, languages, authors, sources } =
    Route.useLoaderData()

  const { idRecipe, ...recipeWithoutID } = recipe

  const dupRecipe = {
    ...recipeWithoutID,
    name: `${recipe.name} copy`,
  }

  return (
    <EditOrCreateRecipe
      originalRecipe={dupRecipe}
      tags={tags}
      allergens={allergens}
      languages={languages}
      authors={authors}
      sources={sources}
    />
  )
}
